import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const fetchEphemeralExercise = (
  exerciseId: string,
  setExercise: Function,
  setLoading: Function,
  language: string,
  setFetchError: Function
) => {
  setLoading(true);

  ApiService.get(`ephemeral-evaluations/exercises/${exerciseId}`)
    .then((response) => {
      setExercise(response.data.ephemeral_exercise);
      setFetchError(false);
    })
    .catch((error) => {
      setFetchError(true);
      console.error("Error fetching ephemeral exercise:", error);
      alert(translate(language, "PAGES.EPHEMERAL_EXERCISE.ERROR"));
    })
    .finally(() => setLoading(false));
};
